import { computed, observable, action } from 'mobx';
import { BaseStore } from './BaseStore';
import { Stores } from '../models/Stores';
import { Translations } from '../models/translations';

export class TranslationStore extends BaseStore {
    @observable.ref translationData = []; // Translation dictionary

    constructor(stores: Stores) {
        super(stores);
    }

    @action
    setTranslationData(data) {
        this.translationData = data;
    }

    // Builds a translation dictionary object for the current culture from all translation data. E.g:
    // { 'phrase': 'translation', 'phrase': 'translation', etc }
    @computed
    get translations(): Translations {
        const translationDictionary = {};
        this.translationData
            .filter(
                translation =>
                    translation.translationCulture === this.stores.data.culture
            )
            .map(
                translation =>
                    (translationDictionary[translation.phrase] =
                        translation.translation)
            );
        return translationDictionary;
    }
}



// WEBPACK FOOTER //
// ./src/stores/TranslationStore.ts